import type { Exercise } from "../api/types";
import { Badge } from "../components/ui";
import { useMountedAccount } from "../auth/auth";
import { accessPills } from "./access";

/** Pastilles de propriété et de partage d'un dossier (docs/17 §8.3) : « par {nom} », « Privé », « Partagé · {n} »,
 *  « Unité », « Lecture seule », « Dossier de l'unité ». Rien en mode hérité. */
export function AccessBadges({ ex, className }: { ex: Exercise; className?: string }) {
  const me = useMountedAccount()?.id ?? null;
  const pills = accessPills(ex, me);
  if (pills.length === 0) return null;
  return (
    <span className={className ?? "inline-flex flex-wrap items-center gap-1"}>
      {pills.map((p) => (
        <Badge key={p.key} size="sm" tone={p.tone}>
          {p.label}
        </Badge>
      ))}
    </span>
  );
}
